var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCompare = function SvgCompare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 22v-1H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h5V2a1 1 0 1 1 2 0v1h.026A1 1 0 0 1 13 5v14h.026A1 1 0 0 1 13 21v1a1 1 0 1 1-2 0m8-4v-1a1 1 0 1 1 2 0v1a3 3 0 0 1-3 3h-1a1 1 0 1 1 0-2h1a1 1 0 0 0 1-1m0-5v-2a1 1 0 1 1 2 0v2a1 1 0 1 1-2 0m0-6V6a1 1 0 0 0-1-1h-1a1 1 0 1 1 0-2h1a3 3 0 0 1 3 3v1a1 1 0 1 1-2 0M5 18a1 1 0 0 0 1 1h5V5H6a1 1 0 0 0-1 1z"
  })));
};
export default SvgCompare;